import { API_AUTH, API_AUTH_FILE} from "../common";

const NhapHangApi = {
  getData: ({
    Type,
    SearchText,
    UserName,
    TrangThai,
    DateFrom,
    DateTo,
    pageIndex,
    pageSize
  }) =>
    API_AUTH.get(
      `QuanLyMuaBan/NhapHang/DanhSachNhapHang?Type=${Type}&SearchText=${SearchText}&UserName=${UserName}&TrangThai=${TrangThai}&DateFrom=${DateFrom}&DateTo=${DateTo}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
      {}
    ),
  getDataInChiTiet:(OrderID) => API_AUTH.get(`QuanLyMuaBan/NhapHang/InNhapHang?OrderID=${OrderID}`,{}),
  xuatExcel: (filters) => {
    const params = { ...filters };
    return API_AUTH_FILE.get("QuanLyMuaBan/NhapHang/XuatExcelDanhSach", params, { responseType: 'blob' });
  },
  getChiTietNhapHang: (OrderID) => 
    API_AUTH.get(`QuanLyMuaBan/NhapHang/GetChiTietNhapHang?orderID=${OrderID}`),
  themSuaNhapHang: (data) => 
    API_AUTH.post(`QuanLyMuaBan/NhapHang/ThemSuaNhapHang`, data),
  xoaDonHang: (OrderID) => 
    API_AUTH.post(`QuanLyMuaBan/NhapHang/XoaDonHang?orderID=${OrderID}`),
}
export default NhapHangApi;